import { useEffect, useState } from 'react'
import debounce from 'lodash/debounce'

/**
 * Check if mobile
 * Reference:
 * https://stackoverflow.com/questions/39435395/reactjs-how-to-determine-if-the-application-is-being-viewed-on-mobile-or-deskto
 */

const THRESHOLD = 1024

export function useIsMobile() {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : THRESHOLD)

  useEffect(() => {
    setWidth(window.innerWidth)
    // Resize event listener
    const handleResize = () => {
      setWidth(window.innerWidth)
    }
    // Attach on Mount
    window.addEventListener('resize', debounce(handleResize, 150))
    return () => {
      // Detach on Unmount
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return width < THRESHOLD
}

export const getIsInitialMobile = () => (typeof window !== 'undefined' ? window.innerWidth < THRESHOLD : true)
